import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { PaymentMethodDto } from 'interfaces/paymentMethods';

interface PaymentMethodsService {
  list(enabled?: boolean): Promise<PaymentMethodDto[]>;
}

const endpoints = {
  paymentMethods: '/payment-methods/enabled',
};

export const paymentMethodsService: PaymentMethodsService = {
  list: async (enabled?: boolean): Promise<PaymentMethodDto[]> => {
    const response: AxiosResponse<ApiResponseDto<PaymentMethodDto[]>> = await apiClient.get(endpoints.paymentMethods, {
      params: { enabled },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
